import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { organizedNeeds, productName, systemFlow } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
export function ProblemSolution() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-181" data-mp="3mr2xsp5146pt">
      <div className="mx-auto max-w-5xl" data-id="element-182" data-mp="3hrghu7xtgcdb">
        <SectionTitle data-id="element-183" data-mp="3hsrkg4fize2u">
          What if your lumbar rehabilitation sessions <Mark data-id="element-184" data-mp="icl98mh1nsk4">were already organized?</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-185" data-mp="idwd0mahp0b8">
          You know the exercises. The challenge is selecting the right ones, adjusting the difficulty, planning the
          session, and knowing what to do next. The <strong className="text-brand-deep" data-id="element-186" data-mp="4k58jsbm86md">{productName}</strong> brings
          together exercises, complete sessions, and professional programming tools to help you prepare individualized
          rehabilitation plans.
        </p>
        <p className="mt-5 text-center text-sm font-black uppercase tracking-[.2em] text-brand" data-id="element-187" data-mp="6sishkfp5yg3">
          Assess. Select. Program. Progress. Reassess.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-188" data-mp="bqu3vzln4h0f">
          <div className="flex flex-col rounded-2xl border border-brand/10 bg-slate-50 p-6" data-id="element-189" data-mp="3u6eh8ms08jkq">
            <h3 className="text-base font-black uppercase leading-tight text-brand-deep md:text-lg" data-id="element-190" data-mp="21anr1pbb199">
              Turn scattered exercises into organized rehabilitation programs
            </h3>
            <div className="mt-3 flex-1 space-y-2 text-sm leading-relaxed text-slate-600" data-id="element-191" data-mp="3p71jv83ibu3w">
              <p data-id="element-192" data-mp="3b70lbzapsyrl">Exercises from videos, courses, and notes can be difficult to organize into complete sessions.</p>
              <p data-id="element-193" data-mp="3f7kg4w7tfqak">
                With this system, you have practical movement instructions, dosage examples, exercise modifications,
                and ready-to-adapt sessions together in one place.
              </p>
            </div>
            <p className="mt-5 text-xs font-black uppercase tracking-wider text-brand" data-id="element-194" data-mp="1dg6916igs0ys">
              More structure. Less preparation. Better organized clinical programs.
            </p>
          </div>

          <div className="flex flex-col rounded-2xl bg-brand p-6" data-id="element-195" data-mp="2hdi29ippa00c">
            <h3 className="text-base font-black uppercase leading-tight text-white md:text-lg" data-id="element-196" data-mp="2de984cqr0049">
              One system. <span className="text-accent-light" data-id="element-197" data-mp="28fg3zaxcplgr">Five essential areas of lumbar rehabilitation.</span>
            </h3>
            <ul className="mt-4 flex-1 space-y-2.5" data-id="element-198" data-mp="353m2rh7ldjn4">
              {organizedNeeds.map(item => <li key={item.question} className="flex items-start gap-2 text-sm text-white/85" data-id="element-199" data-mp="313lobwkht8g2">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-light" aria-hidden="true" data-id="element-200" data-mp="2wa919qvgp9pf" />
                  <span data-id="element-201" data-mp="2rawgrcs2ceq0">
                    {item.question} <strong className="font-bold text-white" data-id="element-202" data-mp="3oswmd6agkoqi">{item.answer}</strong>
                  </span>
                </li>)}
            </ul>
            <ol className="mt-5 flex flex-wrap items-center gap-1.5" data-id="element-203" data-mp="3jzlbmu2izntb">
              {systemFlow.map((step, index) => <li key={step} className="flex items-center gap-1.5" data-id="element-204" data-mp="69ny6sjma0y" data-mpi={index}>
                  {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-accent-light" aria-hidden="true" data-id="element-205" data-mp="8clrczxt7g8" />}
                  <span className="whitespace-nowrap rounded-md bg-white px-2 py-1 text-[10px] font-black uppercase tracking-wide text-brand-deep" data-id="element-206" data-mp="57yzdnjogppk">
                    {step}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}